import { IDamageFollowUp, IDamageInvestigation, IDDFollowUp } from "../models/prException";

export enum EPRStatus {
  exceptionEntry = 1,
  inProgress = 13,
  needsCleared = 12,
  followupInProgress = 14,
}

export const DD_FOLLOW_UP_FEILDS: Array<keyof IDDFollowUp> = [
  "wasCorrectDeliveryStatusEntered",
  "confirmDeliveryCodeMatchesADE",
  "confirmDriverTookValidEPs",
  "f18Note",
];

export const DAMAGE_FOLLOW_UP_FEILDS: Array<keyof IDamageFollowUp> = [
  "doesShipperWantFreightBack",
  "didRcpmApproveDumpBill",
  "wasReturnAuthorizationReceived",
  "clearShipmentStatusRCN",
  "freightBackDetails",
  "valueRangeFollowUp",
  "f18Note2",
];

export const PR_INVESTIGATION_FEILDS: Array<keyof IDamageInvestigation> = [
  "checkSpecialInstructions",
  "specialInstructionsDetails",
  "isAllProductDamaged",
  "canProductBeRecouped",
  "willConsigneeAcceptRedelivery",
  "checkPhotos",
  "updatedF18Notes",
  "shipmentConsistsOf",
  "productDescription",
  "packageType",
  "isPackageDamaged",
  "isProductDamaged",
  "isProductNotDamaged",
  "isPackageRepairable",
  "areValidPicturesAvailable",
  "reasonWhyCannotBeRecouped",
  "consigneePhone",
  "consigneeEmail",
  "consigneeName",
  "checkPhotos",
  ...DD_FOLLOW_UP_FEILDS,
];
